<template>
  <div>
    <fiexd-top v-show="fiexdTopShow"></fiexd-top>
    <search @eventClick="search" class="con"></search>
    <homenav :activeIndex="activeIndex"></homenav>
    <div class="breadcrumb">
      <breadcrumb v-if="show" :list="searchList"></breadcrumb>
    </div>

    <router-view></router-view>
  </div>
</template>


<script>
import homenav from "./home-nav";
import search from "@/components/search.vue";
import fiexdTop from "../../components/plugins/fiexdtop";
export default {
  components: { homenav, search, fiexdTop },
  data() {
    return {
      show: false,
      fiexdTopShow: false,
      searchList: [
        { name: "首页", path: "/" },
        { name: "商品搜索", path: "/search" },
      ],
      activeIndex: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  //   destroyed () {
  //   window.removeEventListener('scroll', this.handleScroll)
  // },
  methods: {
    search() {
      this.$router.push({ name: "search" });
    },
    handleScroll(e) {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 165) {
        this.fiexdTopShow = true;
      } else {
        this.fiexdTopShow = false;
      }
    },
  },
  watch: {
    $route: {
      //||t.name=='detail'
      handler: function (t, f) {
        //console.log(t.name);
        if (t.name == "search") {
          this.show = true;
        } else {
          this.show = false;
        }
        // if(t.name=='home'){
        //   this.activeIndex = 0
        // }else if(t.name=='meal'){
        //   this.activeIndex = 1
        // }else if(t.name=='bargain'){
        //   this.activeIndex = 2
        // }else if(t.name=='getcoupon'){
        //   this.activeIndex = 3
        // }else if(t.name=='activities'){
        //   this.activeIndex = 4
        // }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  background-color: #fafafa;
}
</style>


// WEBPACK FOOTER //
// src/pages/main/index.vue